var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0004 19.5999C12.5465 19.5999 14.9883 18.5885 16.7886 16.7881C18.589 14.9878 19.6004 12.546 19.6004 9.9999C19.6004 7.45382 18.589 5.01203 16.7886 3.21168C14.9883 1.41133 12.5465 0.399902 10.0004 0.399902C7.45431 0.399902 5.01252 1.41133 3.21217 3.21168C1.41182 5.01203 0.400391 7.45382 0.400391 9.9999C0.400391 12.546 1.41182 14.9878 3.21217 16.7881C5.01252 18.5885 7.45431 19.5999 10.0004 19.5999ZM14.4488 8.4483C14.6674 8.22198 14.7883 7.91886 14.7856 7.60422C14.7829 7.28959 14.6567 6.98861 14.4342 6.76612C14.2117 6.54363 13.9107 6.41743 13.5961 6.41469C13.2814 6.41196 12.9783 6.53291 12.752 6.7515L8.80039 10.7031L7.24879 9.1515C7.02247 8.93291 6.71935 8.81196 6.40471 8.81469C6.09007 8.81743 5.7891 8.94363 5.56661 9.16612C5.34412 9.38861 5.21792 9.68959 5.21518 10.0042C5.21245 10.3189 5.3334 10.622 5.55199 10.8483L7.95199 13.2483C8.17702 13.4733 8.48219 13.5996 8.80039 13.5996C9.11859 13.5996 9.42376 13.4733 9.64879 13.2483L14.4488 8.4483Z",
    fill: "#0AB377"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.451983f60eb9712cc79aa90843489cbf.svg";
export { ForwardRef as ReactComponent };